export default __webpack_public_path__ + "static/media/landingpage.513176ec.svg";